import Vue from 'vue'
import Router from 'vue-router'

const index = () => import(/* webpackChunkName:'index'*/ '@/pages/index/index'); //首页
const login = () => import(/* webpackChunkName:'login'*/ '@/pages/login/login'); //登录
const myself = () => import(/* webpackChunkName:'myself'*/ '@/pages/myself/myself'); //我的
const vippage = () => import(/* webpackChunkName:'myself'*/ '@/pages/vippage/vippage'); //开通vip页面
const about = () => import(/* webpackChunkName:'myself'*/ '@/pages/about/about'); //关于我们页面

Vue.use(Router)

export default new Router({
  mode: 'history',
  base:'',
  routes: [
    {path: '/',name: 'index',component: index,meta: {title: '',requireAuth: true,keepAlive:true}},
    {path: '/login',name: 'login',component: login,meta: {title: '',requireAuth: true}},
    {path: '/myself',name: 'myself', component: myself,meta: {title: '信盾科技AI智能陪聊',requireAuth: true},},
    {path: '/vippage',name: 'vippage',component: vippage,meta: {title: '会员开通',requireAuth: true}},
    {path: '/about',name: 'about',component: about,meta: {title: '关于我们',requireAuth: true}},

  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js